import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {logExperiment} from '@homeaway/abacus-client-utils';
import ReactIntersectionObserver from '../../react-intersection-observer/ReactIntersectionObserver';

/**
 * Reports the exposure of a UI AB (aka multivariate) test
 */
class MvtTest extends Component {
    static propTypes = {
        /** The name of the test whose exposure we want to report */
        test: PropTypes.string,
        /** Whether to report on mount (Full Exposure) or on visible (True Exposure) */
        reportOnMount: PropTypes.bool,
        /** The element whose exposure we want to track. See ReactIntersectionObserver children for details. */
        children: ReactIntersectionObserver.propTypes.children
    };

    static defaultProps = {
        reportOnMount: false,
        children: null
    };

    constructor(props) {
        super(props);
        this.state = {hasBeenSeen: false};
    }

    componentDidMount() {
        if (this.props.reportOnMount) {
            this.logExperiment();
        }
    }

    logExperiment() {
        const {abacus, test} = this.props;
        logExperiment(abacus[test]);
    }

    onIntersection = ({isIntersecting}) => {
        this.setState((state) => {
            if (isIntersecting && !state.hasBeenSeen) {
                this.logExperiment();
                return {hasBeenSeen: true};
            }
            return null;
        });
    }

    shouldReportOnVisible() {
        return !this.props.reportOnMount && !this.state.hasBeenSeen;
    }

    render() {
        return this.shouldReportOnVisible() ?
            <ReactIntersectionObserver
                rootMargin="-10px 0px 0px 0px"
                onIntersection={this.onIntersection}
            >
                {this.props.children}
            </ReactIntersectionObserver> :
            this.props.children;
    }
}

const mapStateToProps = ({abacus}) => ({abacus});

export default connect(mapStateToProps)(MvtTest);
